export var checkboxInput = 'h-4 w-4 rounded ring:none';
export var container = 'relative flex items-start';
export var inputContainer = 'flex items-center h-5 self-center outline-none';
export var textContainer = 'ml-3';
//# sourceMappingURL=checkbox-input.styles.js.map